<template>
	<Container class="mx-auto">
		<div class="plans-container">
			<div class="author-card">
				<div class="author-card-img-container">
					<a href="#">
						<img
							class="author-card-img"
							loading="lazy"
							decoding="async"
							src="https://content.timothysykes.com/cdn-cgi/image/quality=55,format=webp,width=456/https://content.timothysykes.com/wp-content/uploads/2021/03/tim-sykes-headshot.png"
							alt="Timothy Sykes"
							data-src="https://content.timothysykes.com/cdn-cgi/image/quality=55,format=webp,width=456/https://content.timothysykes.com/wp-content/uploads/2021/03/tim-sykes-headshot.png"
						/>
					</a>
				</div>
				<div class="author-card-info-container">
					<h1>
						Tim
						<strong>Sykes</strong>
					</h1>
					<h3>
						Teaching
						<a href="/blog/penny-stocks-list/">
							<strong class="author-card-info-strong-deco">Penny Stocks</strong>
						</a>
					</h3>
				</div>
			</div>
			<h4 class="author-card-subtitle">
				Self-made millionaire trader who profits from and teaches the ins and out of
				penny stocks.*
			</h4>
			<div class="lead-container">
				<div class="lead-video-container">
					<iframe
						class="video-cta"
						loading="lazy"
						src="https://player.vimeo.com/video/63616117"
						frameborder="0"
						allowfullscreen="allowfullscreen"
					/>
				</div>
				<div class="lead-info-container">
					<p>
						Tim Sykes's free
						<a
							class="youtube-link external-link"
							href="https://www.youtube.com/@TimothySykesTrader"
							target="_blank"
						>
							YouTube videos
						</a>
						introduce his approach to penny stocks, trading patterns, and market
						preparation. Want to follow what he's watching? Get his free
						<a
							class="other-link external-link"
							:href="afterHoursWatchlistUrl"
							target="_blank"
						>
							After-Hours Watchlist
						</a>
						, The Night Tape, delivered every trading day after the closing bell—plus
						The Second Session, his guide to how after-hours trading works.
					</p>
					<p>
						Interested in his Friday-to-Monday strategy?
						<a
							class="youtube-link external-link"
							href="https://www.youtube.com/watch?v=mfcMnjYuGDc"
							target="_blank"
						>
							Watch Tim's free Weekend Gap video
						</a>
						to see how he approaches news-driven weekend setups, then explore the
						training programs below.
					</p>
				</div>
			</div>
		</div>
	</Container>
	<section class="pricing-plans-container mx-auto">
		<div class="pricing-plans-cta">
			<span class="pricing-plants-cta-title">Choose the right plan for you</span>
			<span class="pricing-plants-cta-subtitle">
				Timothy Sykes has dedicated his career to helping traders like you unleash
				their potential. He provides you with the tools, strategies, and best
				practices needed to become a self-sufficient trader.
			</span>
		</div>

		<div class="plans-alignment">
			<div class="price-post">
				<h2 class="price-post-info-title">Weekend Gap Masterclass</h2>
				<p class="price-post-info-subtitle">
					For learning Tim's Friday-to-Monday approach
				</p>
				<div class="price-post-price-wrapper">
					<h3 class="price-post-price">27</h3>
				</div>
				<a
					class="pricing-plans-btn"
					target="_blank"
					:href="weekendGapUrl"
				>
					Explore the Weekend Gap
				</a>
				<ul class="pricing-plan-list">
					<li class="pricing-plan-item">Step-by-step trading masterclass</li>
					<li class="pricing-plan-item">
						Learn how Tim evaluates news, entries, exits, and risk
					</li>
					<li class="pricing-plan-item">Friday Weekend Gap Report</li>
				</ul>
			</div>
			<div class="price-post supernova">
				<p class="supernova-superpopular">&#x1F680; Most popular</p>
				<div class="supernova-wrapper">
					<h2 class="price-post-info-title">Supernova Indicator</h2>
					<p class="price-post-info-subtitle">
						For studying small-stock momentum setups
					</p>
					<div class="price-post-price-wrapper">
						<h3 class="price-post-price">19.99</h3>
					</div>
					<a
						class="pricing-plans-btn"
						target="_blank"
						:href="supernovaUrl"
					>
						Explore the Supernova Indicator
					</a>
					<ul class="pricing-plan-list">
						<li class="pricing-plan-item">Supernova indicator code</li>
						<li class="pricing-plan-item">
							Getting Started Masterclass and installation walkthrough
						</li>
						<li class="pricing-plan-item">Signal cheat sheets and customization guide</li>
					</ul>
				</div>
			</div>
			<div class="price-post">
				<h2 class="price-post-info-title">The Timothy Sykes Letter</h2>
				<p class="price-post-info-subtitle">For exploring AI-generated trade ideas</p>
				<div class="price-post-price-wrapper">
					<h3 class="price-post-price">49.00</h3>
				</div>
				<a
					class="pricing-plans-btn"
					target="_blank"
					:href="letterUrl"
				>
					Explore XGPT
				</a>
				<ul class="pricing-plan-list">
					<li class="pricing-plan-item">XGPT-generated stock picks</li>
					<li class="pricing-plan-item">
						Weekly live trading opportunities with Tim Bohen
					</li>
					<li class="pricing-plan-item">
						Tim Sykes's trading checklists and educational resources
					</li>
				</ul>
			</div>
		</div>
	</section>
	<div class="testimonials-container">
		<div class="testimonial">
			<img
				src="/images/testimonials-image-1.png"
				alt="Michaela Scott"
			/>
			<div class="testimonial-text-wrapper">
				<p class="testimonial-text">
					"Thanks to Timothy Sykes' guidance and support, I've gained the confidence
					and knowledge to navigate the complexities of trading. He is a true mentor
					who genuinely cares about his students' success."
				</p>
				<p class="testimonial-subtext">Michaela Scott</p>
				<p class="testimonial-subtext-subtext">Mother and Trader</p>
			</div>
			<div class="giant-quote-container">
				<span class="giant-quote">"</span>
			</div>
		</div>
	</div>

	<Row style="background-color: transparent">
		<Container>
			<FAQ
				v-if="faqData"
				:faqs="faqData"
				:processed-title="title"
			/>
		</Container>
	</Row>

	<Row class="apply-challenge-section pb-0">
		<Container class="xl:grid grid-cols-2">
			<div class="mb-[32px] lg:mb-0">
				<Heading
					tag="h2"
					type="big"
					class="text-white mb-[16px] lg:mb-[24px]"
					text="Ready to take action?"
				/>

				<Paragraph class="text-white mb-[16px] lg:mb-[24px]">
					Every trading day after the closing bell, I send you The Night Tape: the
					stocks moving after hours, what's driving them, and what I'm watching for the
					next morning. Plus, get my free guide, The Second Session, to learn how
					after-hours trading works.
				</Paragraph>

				<JoinPitch
					:is-white="true"
					class="mb-[16px] lg:mb-[24px]"
				/>
				<LeadCaptureForm id="ts-watchlist-optin-int-a" />
			</div>
			<div>
				<img
					src="/images/assets/sykes-cta-1.webp"
					width="600"
					height="447"
					loading="lazy"
					class="ready-to-take-action-1"
					alt="sykes-cta-1 image"
				/>
				<img
					src="/images/assets/sykes-cta-2.webp"
					width="393"
					height="621"
					loading="lazy"
					alt="sykes-cta-2 image"
					class="ready-to-take-action-2"
				/>
			</div>
		</Container>
	</Row>

	<Head>
		<Title>{{ yoast_head_json?.title }}</Title>
		<Link
			rel="canonical"
			:href="current_hostname + 'plans/'"
		/>

		<template v-if="head_seo">
			<template
				v-for="(tag, i) in head_seo"
				:key="i"
			>
				<Meta
					v-if="tag[0].startsWith('og_')"
					:property="'og:' + tag[0].slice(3)"
					:content="tag[1][0].url || tag[1]"
				/>

				<Meta
					v-else-if="tag[0].startsWith('article')"
					:property="'article:' + tag[0].slice(8)"
					:content="tag[1]"
				/>
				<Meta
					v-else-if="tag[0] !== 'twitter_misc' && tag[0].startsWith('twitter')"
					:name="'twitter:' + tag[0].slice(8)"
					:content="tag[1]"
				/>

				<template v-else-if="tag[0] === 'twitter_misc'">
					<Meta
						:name="'twitter:label1'"
						:content="Object.keys(tag[1])[0]"
					/>
					<Meta
						:name="'twitter:data2'"
						:content="Object.values(tag[1])[0]"
					/>
					<Meta
						:name="'twitter:label2'"
						:content="Object.keys(tag[1])[1]"
					/>
					<Meta
						:name="'twitter:data1'"
						:content="Object.values(tag[1])[1]"
					/>
				</template>

				<Meta
					v-else-if="tag[0] != 'og_image'"
					:name="tag[0]"
					:content="tag[1]"
				/>
				<template v-else>
					<Meta
						:property="tag[0].split('_').join(':') + ':type'"
						:content="tag[1][0].type"
					/>
					<Meta
						:property="tag[0].split('_').join(':')"
						:content="tag[1][0].url"
					/>
					<Meta
						:property="tag[0].split('_').join(':') + ':width'"
						:content="tag[1][0].width"
					/>
					<Meta
						:property="tag[0].split('_').join(':') + ':height'"
						:content="tag[1][0].height"
					/>
				</template>
			</template>
		</template>
	</Head>
</template>
<script setup>
import axios from "axios";
import FAQ from "@/components/FAQ.vue";

const { current_hostname } = useRuntimeConfig().public;
const hostname = useRuntimeConfig().public.hostname;

const afterHoursWatchlistUrl = useCampaignUrl(
	"https://traders.timothysykes.com/after-hours/night-tape?utm_medium=ts.com&utm_source=tim&utm_term=web_ads&utm_campaign=oKfY7g"
);
const weekendGapUrl = useCampaignUrl(
	"https://trading.timothysykes.com/weekend-gap/step/twg-hybrid-cart/?utm_medium=website&utm_source=plans"
);
const supernovaUrl = useCampaignUrl(
	"https://trading.timothysykes.com/snt-indicator/step/indicator-cart/?utm_medium=ts.com&utm_source=tim&utm_term=web_ads&utm_campaign=T1HWJI"
);
const letterUrl = useCampaignUrl(
	"https://trading.timothysykes.com/ts1-trump/step/ts1-cart/?utm_medium=ts.com&utm_source=tim&utm_term=web_ads&utm_campaign=QKXzf1"
);

const faqData = ref([
	{
		title: "My broker says it's not possible to short sell penny stocks",
		answer:
			"Your broker stinks! You can short ANY stock down to 1 penny/share as long as your broker can find shares to short, this is my gift and curse. ..."
	},
	{
		title: "If your strategy is so good, why do you teach and not just trade?",
		answer:
			"As I explained above, my strategy does not work with $100 million or $1 billion which is what most hedge funds have because the companies are small so the profit opportunities range from $1,000 to $200,000... still good money to a lot of people, which is why I teach individuals. ..."
	},
	{
		title: "Aren't penny stocks dangerous?",
		answer:
			"Yes, but over the past few years' even investments previously considered 'Safe' like mutual funds have been discovered to be rather dangerous. Despite my making millions of dollars, I am nowhere near a great trader - as my longterm students will attest - and the key to my protecting my account is that I cut losses EXTREMELY quick if I'm ever caught with a stock heading in the wrong direction. Also, when you have a small account, you need to take more risks in order to be able to grow your nest egg exponentially to make it worth your time even investing/trading in the stock market. I know too many 'safe' investors who spend countless hours researching and debating and yet their yearly profits are less than that of a part-time Starbucks barista aka not worth the time!"
	},
	{
		title: "Which plan should I choose?",
		answer:
			"My most popular plan is my <a class='price-link' href='https://profit.ly/purchase/16'>PennyStocking Silver plan</a> — as you receive access to not only my chatroom, daily watchlists and real-time trading alerts, but you also receive daily video watchlists, access to my 9,000+ video lesson library and new in-depth trade review webinars weekly! <a class='price-link' href='https://profit.ly/purchase/26?aff=11939'>TIMalerts</a> still provides a great bang for the buck with daily watchlists, chatroom access and real-time trading alerts. My <a class='price-link' href='https://www.timothysykes.com/millionaire-challenge/'>Trading Challenge</a> is something you'll have to apply for…"
	},
	{
		title: "What kind of teacher is Timothy Sykes?",
		answer:
			"A busy one. Because of my personal trading success and the success of my thousands of students around the world, I receive upwards of 2,000 emails/day. I try to respond to all of them, but my now 9.000+ video lessons and over one dozen instructional DVD guides answer most titles so please use the educational products I've worked to create to your advantage. The chart patterns and trading setups on which I profit happen time and again, it's up to you to be prepared to profit from them... let me be the teacher for you that I never had but always wished I'd had (Despite the millions of dollars I've made, I've lost hundreds of thousands of dollars on boneheaded mistakes and missed opportunities... mistakes I can help you avoid and opportunities I can help you take advantage of!)"
	}
]);

const title = "Frequently Asked Questions";

const head_seo = computed(() => {
	if (yoast_head_json) {
		const filtered = Object.entries(yoast_head_json).filter(
			(item) =>
				![
					"title",
					"robots",
					"canonical",
					"schema_json",
					"WordPressAuthor_YoastHeadJson_Schema_"
				].includes(item[0])
		);
		return filtered;
	}

	return null;
});

const { data } = await useAsyncData("page_seo_data", async () => {
	const { data } = await axios.get(`${hostname}wp-json/wp/v2/pages/19894/`);

	const { yoast_head_json } = data;

	return { yoast_head_json };
});

const { yoast_head_json } = data.value;
</script>
<style lang="scss" scoped>
@import "@assets/utils.scss";

.plans-container {
	padding: 40px 0 0 0;
	margin-bottom: 32px;

	@include breakpoint(lg) {
		padding: 80px 0;
	}
}

.author-card {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-bottom: 32px;

	@include breakpoint(lg) {
		flex-direction: row;
		display: flex;
		justify-content: center;
		text-align: flex-start;
		margin-bottom: 32px;
	}
}

.author-card-img {
	max-height: 162px;
	max-width: 100%;
	height: auto;
	display: block;
}

.author-card-info-container {
	display: flex;
	flex-direction: column;
	text-align: center;

	@include breakpoint(lg) {
		display: flex;
		justify-content: center;
		margin-left: 32px;
	}
}

.author-card-info-container h1 {
	font-size: 24px;

	@include breakpoint(lg) {
		font-size: 32px;
		font-weight: 600;
		text-align: start;
	}
}

.author-card-info-container h3 {
	font-size: 18px;
	padding-bottom: 16px;

	@include breakpoint(lg) {
		font-size: 22px;
		padding-bottom: 25px;
	}
}

.author-card-info-strong-deco {
	color: #1e3a8a;
}

.author-card-subtitle {
	text-align: center;
	font-family: Rubik;
	font-size: 16px;
	padding-bottom: 32px;

	@include breakpoint(lg) {
		font-size: 20px;
		padding-bottom: 22px;
	}
}

.lead-container {
	flex-direction: column;
	padding: 0;

	@include breakpoint(lg) {
		display: grid;
		grid-template-columns: 1fr 1fr;
		padding: 64px 0;
	}
}

.lead-video-container {
	@include breakpoint(lg) {
		flex: 1;
	}
}

.video-cta {
	width: 100%;
	min-height: 220px;
	max-height: auto;
	overflow: hidden;

	@include breakpoint(lg) {
		width: 640px;
		height: 360px;
	}
}

.lead-info-container {
	width: 100%;
	padding-left: 0;
	margin-top: 16px;

	@include breakpoint(lg) {
		margin-top: 0;
		flex: 1;
		width: 100%;
		padding-left: 32px;
	}
}

.lead-info-container p {
	margin-bottom: 1.666666666667em;
	line-height: 1.8;
	font-family: Rubik;
	font-size: 16px;
	text-align: center;

	@include breakpoint(lg) {
		text-align: left;
	}
}

.pricing-plans-grid {
	display: grid;
	grid-template-columns: repeat(3, minmax(220px, 400px));
	grid-column-gap: 24px;
	justify-content: center;
}

.pricing-plans-container {
	padding: 0 16px;

	@include breakpoint(lg) {
		padding: 0 116px;
		text-align: center;
	}
}

.pricing-plans-cta {
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	margin-bottom: 16px;

	@include breakpoint(lg) {
		margin-bottom: 92px;
	}
}

.pricing-plants-cta-title {
	display: inline-block;
	width: 100%;
	color: var(--base-black, #000);
	text-align: center;
	font-family: Fira Sans;
	font-size: 24px;
	font-style: normal;
	font-weight: 700;
	line-height: 120%; /* 57.6px */
	letter-spacing: -0.96px;
	margin-bottom: 16px;

	@include breakpoint(lg) {
		font-size: 48px;
	}
}

.pricing-plants-cta-subtitle {
	display: inline-block;
	width: auto;
	color: var(--neutrals-slate-800, #1e293b);
	text-align: center;
	font-family: Rubik;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 29.6px */
	overflow: hidden;

	@include breakpoint(lg) {
		font-size: 18px;
		width: 648px;
	}
}

.price-post {
	display: inline-block;
	width: 100%;
	height: auto;
	padding: 40px;
	flex-direction: column;
	align-items: flex-start;
	gap: 24px;
	flex-shrink: 0;
	background-color: #ffffff;
	border: 1px solid #e2e8f0;
	border-radius: 16px;
	box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
	margin-bottom: 32px;
	min-height: 512px;

	@include breakpoint(lg) {
		width: auto;
		margin-bottom: 10px;
	}
}

.price-post-info-title {
	width: auto;
	color: var(--neutrals-slate-800, #1e293b);
	font-family: Fira Sans;

	font-size: 24px;
	font-style: normal;
	font-weight: 700;
	line-height: 120%; /* 45.6px */
	letter-spacing: -0.76px;
	text-align: center;

	@include breakpoint(lg) {
		width: 350px;
		font-size: 38px;
		text-align: left;
	}
}

.price-post-info-subtitle {
	width: auto;
	color: var(--neutrals-slate-800, #1e293b);
	font-family: Rubik;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 29.6px */
	text-align: center;

	@include breakpoint(lg) {
		width: 350px;
		font-size: 18px;
		text-align: left;
	}
}

.price-post-price-wrapper {
	display: block;
	align-items: center;
	text-align: center;
	gap: 8px;
	align-self: stretch;
	margin: 8px auto;

	@include breakpoint(lg) {
		display: flex;
		margin-top: 40px;
	}
}

.price-post-price {
	color: var(--neutrals-slate-800, #1e293b);
	text-align: center;
	font-family: Fira Sans;
	font-size: 36px;
	font-style: normal;
	font-weight: 700;
	line-height: 120%; /* 57.6px */
	letter-spacing: -0.96px;

	align-items: flex-start;
	display: inline-block;

	@include breakpoint(lg) {
		display: flex;
		font-size: 48px;
	}
}

.price-post-price::before {
	content: "$";
	color: var(--neutrals-slate-800, #1e293b);
	text-align: center;
	font-family: DM Sans;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 150%; /* 30px */

	@include breakpoint(lg) {
		font-size: 20px;
	}
}

.price-post-duration {
	display: inline-block;
	color: var(--neutrals-slate-800, #1e293b);
	font-family: Rubik;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 29.6px */
	text-align: left;

	@include breakpoint(lg) {
		flex: 1 0 0;
		font-size: 18px;
	}
}

.pricing-plans-btn {
	margin: 24px 0;
	display: flex;
	padding: 8px 16px;
	justify-content: center;
	align-items: center;
	gap: 4px;
	align-self: stretch;
	border-radius: 8px;
	background: var(--primary-blue-700, #1d4ed8);
	color: var(--base-white, #fff);
	text-align: center;
	font-family: Fira Sans;
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: 25px; /* 138.889% */

	@include breakpoint(lg) {
		font-size: 18px;
		padding: 12px 24px;
	}
}

.prcing-plans-btn::after {
	content: "";
	display: inline-block;
	width: 24px;
	height: 24px;
	margin-right: 16px;
	background-image: url("../public/images/right-arrow.svg");
	background-size: cover;
	vertical-align: middle;
}

.pricing-plan-list {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 8px;
	align-self: stretch;

	@include breakpoint(lg) {
		gap: 16px;
	}
}

.pricing-plan-item {
	color: var(--neutrals-slate-800, #1e293b);
	font-family: Rubik;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 160%;

	@include breakpoint(lg) {
		font-size: 18px;
	}
}

.pricing-plan-item::before {
	content: "";
	display: inline-block;
	width: 24px;
	height: 24px;
	margin-right: 16px;
	background-image: url("../images/check-circle.svg");
	background-size: cover;
	vertical-align: middle;
}

.supernova {
	margin: 0px;
	margin-bottom: 32px;
	padding: 0 0px 20px 0px;
	box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);

	@include breakpoint(lg) {
		margin: 0 40px;
		margin-bottom: 10px;
		padding: 0;
	}
}

.supernova-superpopular {
	background: linear-gradient(274deg, #68c1d4 -2.98%, #00057d 102.44%);
	color: #fff;
	text-align: center;
	font-family: Rubik;
	font-size: 15px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 22.14px */
	letter-spacing: 1px;
	margin-bottom: 32px;
	text-transform: uppercase;
	padding: 8px 0;
	width: 100%;
	border-radius: 16px 16px 0 0;
}

.supernova-wrapper {
	padding: 0 40px 40px 40px;

	@include breakpoint(lg) {
		padding: 0 20px 20px 20px;
	}
}

.testimonials-container {
	display: block;
	justify-content: center;
	margin: 32px 28px;
	height: auto;

	@include breakpoint(lg) {
		display: flex;
		margin: 64px auto;
	}
}

.testimonial {
	flex-direction: column;
	text-align: center;
	padding: 16px;
	max-width: 100%;
	margin: 0 auto;
	height: auto;
	width: auto;
	border-radius: 16px;
	background: #fff;
	box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);

	@include breakpoint(lg) {
		flex-direction: row;
		display: flex;
		width: 1037px;
		height: 262px;
		padding-right: 38px;
		justify-content: center;
		text-align: start;
		gap: 32px;
		flex-shrink: 0;
		position: relative;
	}
}

.testimonial-img-container {
	@include breakpoint(lg) {
		display: flex;
	}
}

.testimonial img {
	width: auto;
	height: auto;
	vertical-align: middle;
	margin: 0 auto;

	@include breakpoint(lg) {
		display: block;
		height: auto;
		max-width: 100%;
	}
}
.testimonial-text {
	width: 100%;
	color: #000;
	font-family: Rubik;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 160%;
	margin-top: 16px;

	@include breakpoint(lg) {
		width: 618px;
		font-size: 18px;
		margin-top: 0;
	}
}

.testimonial-subtext {
	margin-top: 24px;
	color: var(--primary-blue-700, #1d4ed8);
	font-family: Fira Sans;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 120%;

	@include breakpoint(lg) {
		font-size: 16px;
	}
}

.testimonial-subtext-subtext {
	margin-top: 8px;
	color: var(--neutrals-slate-500, #64748b);
	font-family: Rubik;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%; /* 24px */

	@include breakpoint(lg) {
		font-size: 14px;
	}
}

.giant-quote-container {
	display: none;

	@include breakpoint(lg) {
		position: absolute;
		bottom: -430px;
		right: 20px;
		display: block;
	}
}

.giant-quote {
	color: #eff6ff;
	font-family: Atkinson Hyperlegible;
	font-size: 300px;
	font-style: normal;
	font-weight: 700;
	line-height: 120%;
	opacity: 0.5;

	@include breakpoint(lg) {
		font-size: 600px;
	}
}

.youtube-link {
	color: #3b82f6;
}

.other-link {
	color: #3b82f6;
}

.plans-alignment {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	@include breakpoint(lg) {
		flex-direction: row;
	}
}
</style>
